import React from 'react'
import styles from './Login.module.css'
import mainlogo from '../Images/Mainlogo.svg'

const Login = () => {
  return (
    <>
        <div className={styles.create}>
                <div className={styles.inputArea}>
                    <div className={styles.form}>
                        <div className={styles.formNmae}>
                            <div className={styles.formHeading}>Username or email</div>
                            <input type="text" placeholder='Username' className={styles.innerInput} />
                        </div>
                        <div className={styles.formNmae}>
                            <div className={styles.formHeading} style={{ marginTop: "57px" }}>Password</div>
                           <input type="text" placeholder='Password' className={styles.innerInput} />
                        </div>
                        <div className={styles.already} style={{ marginTop: "49px" }}>I already have a user account</div>
                    </div>
                </div>
                <div className={styles.portal}>
                    <img src={mainlogo} className={styles.mainlogo} alt="" />
                    <div className={styles.metrics}>MapMetrics</div>
                    <div className={styles.lowerText}>Bussiness Portal</div>
                </div>
            </div>
    </>
  )
}

export default Login
